const QGIV = QGIV || {};

function FormLanding() {
    function adjustHeaderHeightForContent() {
        // header text container contains the logo image as well. Added a 2nd case
        // to make the height even larger in the scenario they have both a long subheader
        // and a logo image present. Only effects mobile devices.
        const $headerTextContainer = $("#header-text-container");
        if ($(window).width() < 600) {
            if (
                $headerTextContainer.height() > 325 &&
                $headerTextContainer.height() < 425
            ) {
                $(".page-header-background").css("height", "400px");
            }
            if ($headerTextContainer.height() >= 425) {
                $(".page-header-background").css("height", "500px");
            }
        }
    }

    function init() {
        adjustHeaderHeightForContent();
    }

    return {
        init: init(),
    };
}

const formLanding = new FormLanding();

$(formLanding.init);
